import { render, staticRenderFns } from "./EditOptionArticleModal.vue?vue&type=template&id=15893322"
import script from "./EditOptionArticleModal.vue?vue&type=script&lang=ts"
export * from "./EditOptionArticleModal.vue?vue&type=script&lang=ts"
import style0 from "./EditOptionArticleModal.vue?vue&type=style&index=0&id=15893322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports